import axios from 'axios';
import BaseAPI from './base/base-api';

class CustomsDeclarationAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'InvoiceBotsAPI';
	controllerName = 'declaration';
}

export default new CustomsDeclarationAPI();
